/* eslint-disable @stylexjs/valid-styles */
import Carousel from "@/design-system/carousel";
import TelemetryButton from "@/design-system/telemetry-button";
import { useViewportInfoContext } from "@/src/contexts";
import { jumpToSectionId } from "@Components/Modules/Helpers";
import * as stylex from "@stylexjs/stylex";

import {
    type QueryMdMaxToSmMin,
    type QueryXsMax,
    colors,
    genericStyles,
} from "../../../styles/tokens.stylex";
import RoundTile from "../../common/RoundTile";
import type { ICashbackBrandTile } from "../CashbackCommonInterfaces";

interface IFavoriteCashbackBrands {
    favoriteList: ICashbackBrandTile[];
    favoriteBtnScrollToId: string;
    addMoreFavText: string;
}

export default function FavoriteCashbackBrands(props: IFavoriteCashbackBrands) {
    const { isMobile } = useViewportInfoContext();

    return (
        <div {...stylex.props(styles.carouselWrapper)}>
            <Carousel showArrows={!isMobile} styleX={styles.carousel} itemStyleX={styles.carouselItem}>
                {props.favoriteList?.map((item, index) => (
                    <RoundTile key={item?.id || index} {...item} showSave />
                ))}
                {props.favoriteBtnScrollToId && (
                    <TelemetryButton
                        as="button"
                        variant="transparent"
                        size="None"
                        styleX={styles.buttonDiv}
                        onClick={() => jumpToSectionId(props.favoriteBtnScrollToId)}
                        eventName="cshbck-AddFavoriteBrand"
                        tabIndex={0}
                    >
                        <span {...stylex.props(styles.plus)}>+</span>
                        <span>{props.addMoreFavText}</span>
                    </TelemetryButton>
                )}
            </Carousel>
        </div>
    );
}

const xsMax: QueryXsMax = "@media (max-width: 759px)";
const mdMax: QueryMdMaxToSmMin = "@media (max-width: 1239px) and (min-width: 760px)";

const styles = stylex.create({
    carouselWrapper: {
        marginBlock: "0",
        marginInline: "-10px",
    },
    carousel: {
        gap: 0,
        gridAutoColumns: {
            default: 100 / 7 + "%",
            [mdMax]: 100 / 5 + "%",
            [xsMax]: 100 / 3.5 + "%",
        },
    },

    carouselItem: {
        padding: {
            default: "0 10px",
            [xsMax]: "0 5px",
        },
    },

    buttonDiv: {
        borderRadius: genericStyles.borderRadiusFullRound,

        gap: "10px",

        transition: "opacity 120ms ease-in-out",
        alignItems: "center",
        aspectRatio: "1/1",
        backgroundColor: "#1b26700d",
        color: colors.fg_BrandBlue,
        display: "flex",
        flexDirection: "column",
        fontSize: {
            default: "1rem",
            [xsMax]: "0.875rem",
        },
        justifyContent: "center",
        opacity: {
            default: 0.6,
            ":hover": 1,
        },
        userSelect: "none",
        width: "100%",
    },

    plus: {
        fontSize: {
            default: "86px",
            [xsMax]: "54px",
        },
        lineHeight: {
            default: "48px",
            [xsMax]: "28px",
        },
    },
});
